import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigService,
    ConfirmationServiceReportModel,
} from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-service-report',
    templateUrl: './confirmation-service-report.component.html',
    styleUrls: ['./confirmation-service-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationServiceReportComponent {
    @Input()
    public model: ConfirmationServiceReportModel;

    @Input()
    public parentForm: FormArray;

    public cseEmail = '';
    public enableDataMaintenanceEnhancement: boolean;
    public constructor(
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        if (this.clientManager.isNgmAA()) {
            this.cseEmail = this.configService.getCseEmailFax();
        }
        this.enableDataMaintenanceEnhancement = this.configService.getShowDataMaintenanceEnhancement();
    }

    public setCrmLongTextNOSRSetValue(): void {
        if (this.model.reportVisibilityToCustomer.getSelectedValue() === ConfigConstants.optionValueNo) {
            this.model.crmLongTextNOSRSet.value = ConfigConstants.sapTrue;
        } else {
            this.model.crmLongTextNOSRSet.value = '';
        }
    }
}
